import type { SearchLocation } from '@/scopes/search/search/infrastructure/api/types'
import { Card } from '@/scopes/common/components/Card'
import { space } from '@sunwebgroup/ui-components'
import { Typography } from '@sunwebgroup/ui-components/uds'
import * as React from 'react'
import { styled } from 'styled-components'
import { ImageCarousel } from './ImageCarousel'
import { LocationTag } from './LocationTag'
import { OverlayLink } from './OverlayLink'
import { ScoreRatings } from './ScoresRatings'

export interface ProductCardCompactProps {
  id: number
  accommodationId: number
  href?: string
  imageSources: string[]
  locations?: SearchLocation[]
  name?: string
  userRating?: number
  userRatingText: string
  rating: number
}

const StyledProductCardCompactWrapper = styled(Card)`
  position: relative;
`

const ImageWrapper = styled.div`
  height: 216px;

  @media (hover: hover) {
    &:hover {
      button {
        display: inline-flex;
      }
    }
  }
`

const StyledLocationTag = styled(LocationTag)`
  margin-top: ${space('primitives_space_8')};
`

const StyledContentWrapper = styled.div`
  padding: ${space('primitives_space_16')};
`

export function ProductCardCompact({
  id,
  href,
  imageSources,
  locations,
  name = '',
  userRating,
  userRatingText,
  rating,
}: ProductCardCompactProps) {
  return (
    <StyledProductCardCompactWrapper>
      {href && <OverlayLink href={href} aria-label={name} target="_blank" />}
      {' '}
      <ImageWrapper>
        <ImageCarousel imageIndex={id} images={imageSources.map(imageSrc => ({ src: imageSrc, alt: name }))} />
      </ImageWrapper>
      <StyledContentWrapper>
        {userRating !== undefined && userRating > 0 && (
          <ScoreRatings rating={rating} userRating={userRating} aria-label={userRatingText} />
        )}
        <Typography variant="display-g-regular" forwardedAs="p">
          {name}
        </Typography>
        {locations && <StyledLocationTag locations={locations} />}
      </StyledContentWrapper>
    </StyledProductCardCompactWrapper>
  )
}

ProductCardCompact.displayName = 'ProductCardCompact'
